// ═══════════════════════════════════════════════════════════════
// useContentSnippets – a tartalom-változók (globális + a szervezet saját), a szervezet adataival kitöltve
// Közös gyorsítótár; mentés / törlés után az invalidateContentSnippets() frissít.
// ═══════════════════════════════════════════════════════════════
import { useEffect, useState } from 'react';
import { ApiClient, type ContentSnippet } from '../api/client';
import { useAuth } from '../context/AuthContext';

let cache: { key: string; promise: Promise<ContentSnippet[]> } | null = null;
const listeners = new Set<() => void>();

export function invalidateContentSnippets() {
  cache = null;
  listeners.forEach((l) => l());
}

export function useContentSnippets(enabled: boolean, tenantId?: number) {
  const { tenant } = useAuth();
  const key = tenantId ? `t${tenantId}` : `a${tenant?.id ?? ''}`;
  const [items, setItems] = useState<ContentSnippet[]>([]);
  const [rev, setRev] = useState(0);
  useEffect(() => {
    const l = () => setRev((r) => r + 1);
    listeners.add(l);
    return () => { listeners.delete(l); };
  }, []);
  useEffect(() => {
    if (!enabled) return;
    if (!cache || cache.key !== key) {
      cache = { key, promise: ApiClient.getContentSnippets(tenantId).then((r) => (r.ok && r.data ? r.data : [])).catch(() => []) };
    }
    let alive = true;
    cache.promise.then((d) => { if (alive) setItems(d); });
    return () => { alive = false; };
  }, [enabled, key, tenantId, rev]);
  return items;
}
